import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../Components/utils/getToken";

/** Fire-and-forget contact activity log (call / WhatsApp / email). */
export async function logCrmContactActivity(leadId, contactType) {
  if (!leadId || !contactType) return null;
  const token = decryptToken("accessToken") || "";
  try {
    const res = await fetch(`${API_BASE_URL}/leads/log-contact/${leadId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ type: contactType }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      if (res.status === 403) {
        return { blocked: true, message: err.message || "Contact blocked" };
      }
      return null;
    }
    return res.json();
  } catch {
    return null;
  }
}
